import Extend from 'flarum/common/extenders';
import ToolsPage from './components/ToolsPage';
export default [new Extend.Routes().add('devconnect.tools', '/tools', ToolsPage)];